export default __webpack_public_path__ + "static/media/uaeFlag.fb76a89a.png";